import React from "react";
import PropTypes from "prop-types";
import styles from "./ErrorList.module.css";
import ErrorItem from "../ErrorItem";

/**
 *
 * Scrollable list of errors with a header.
 */

export function ErrorList({ errors }) {
  return (
    <>
      <div className={styles.container}>
        <div>ID</div>
        <div>Date</div>
        <div>Description</div>
      </div>
      <div className={styles.list}>
        {errors.map((error) => (
          <ErrorItem error={error} key={error._id} />
        ))}
      </div>
    </>
  );
}

ErrorList.propTypes = {
  /**
   * Array of error objects
   */
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      timestamp: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};
